export type Kind =
  | 'text'
  | 'emote'
  | 'notice'
  | 'image'
  | 'file'
  | 'audio'
  | 'video'
  | 'location'
  | 'other';
export type MessageStatus = 'read' | 'sent' | 'sending' | 'error';

export interface ChatUser {
  uid: string;
  firstname: string;
  lastname: string;
  displayName?: string;
  isSender: boolean;
  status?: 'online' | 'unavailable' | 'offline';
}

export interface AnyMessageGeneric<
  T extends Kind,
  U extends ChatUser,
  C extends Record<string, unknown>
> {
  id?: string;
  txnId?: string;
  roomId?: string;
  kind: T;
  user: U;
  content: C;
  date: Date;
  error?: string;
  status?: MessageStatus;
}

export type AnyMessage = AnyMessageGeneric<
  Kind,
  ChatUser,
  Record<string, unknown>
>;

export type TextMessage = AnyMessageGeneric<
  'text',
  ChatUser,
  {
    text: string;
  }
>;

export function isTextMessage(message: AnyMessage): message is TextMessage {
  return message.kind === 'text';
}
